import React from 'react';
import ReactDOM from 'react-dom/client';
import { StyledEngineProvider } from '@mui/material/styles';
import { BrowserRouter } from "react-router-dom";
import './i18n';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider } from "./Theme";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <StyledEngineProvider injectFirst>
    <BrowserRouter basename={''}>
      {/*<BrowserRouter>*/}
      <ThemeProvider>
        {/*<React.StrictMode>*/}
        <App />
        {/*</React.StrictMode>*/}
      </ThemeProvider>
    </BrowserRouter>
  </StyledEngineProvider >
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
